export const projectBaseURL = '/img/';
